import ExlyModal from "common/Components/ExlyModal";
import React from "react";
import QuestionsForms from "schedule-v2/commonPages/Components/QuestionCards/QuestionsForm";
import useStyles from "./BookedSession.styles";
import { isMultiQuestionType } from "./utils/QuestionsPage.utils";

// const initial_state = {
//   questionObj: {},
// };

export default function QuestionsFormModal(props) {
  const classes = useStyles();
  // If Multi Type Question then we will not allow user to edit these custom Questions
  const isQuestionMultiType = isMultiQuestionType(props?.record?.type);

  return (
    <ExlyModal
      title={props.title}
      open={props.isOpen}
      onPrimaryBtnClick={props.handleSubmit}
      primaryBtnProps={{ disabled: isQuestionMultiType }}
      onClose={props.closeModal}
      primaryBtnText={props.ctaText}
      modal_props={{
        modalPaperClassName: classes.modalPaperClass,
      }}
    >
      <QuestionsForms record={props?.record} />
    </ExlyModal>
  );
}
